import { InformationRequestStatus, Prisma } from "@tfg/db"
import { z } from "zod"

export const transferContactSchemaUpdate = z.object({
  operationsIds: z.array(z.number()),
  updateValue: z.boolean(),
})
export type transferContactValidationUpdateType = z.infer<
  typeof transferContactSchemaUpdate
>

export const traceabilityRequestTypeSchema = z.object({
  type: z.enum(["product", "component", "material"]),
  typeTextContent: z.object({
    originalText: z.string(),
  }),
})

export type traceabilityRequestType = z.infer<
  typeof traceabilityRequestTypeSchema
>

export const sortValueSchema = z.object({
  value: z.nativeEnum(Prisma.SortOrder),
  rank: z.coerce.number(),
})

export const getTraceabilityRequestsQueryParamsSchema = z.object({
  filters: z
    .object({
      status: z.nativeEnum(InformationRequestStatus),
      type: z.string(),
      clientId: z.string(),
      search: z.string(),
    })
    .partial()
    .optional(),
  sort: z
    .object({
      orderDate: sortValueSchema,
      dueDate: sortValueSchema,
      receptionDate: sortValueSchema,
      reference: sortValueSchema,
      client: sortValueSchema,
    })
    .partial()
    .optional(),
  pagination: z
    .object({
      page: z.coerce.number(),
      pageSize: z.coerce.number().positive(),
    })
    .optional(),
})

export type getTraceabilityRequestsQueryParams = z.infer<
  typeof getTraceabilityRequestsQueryParamsSchema
>
